import { Component, Input, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import { Router } from "@angular/router";
import * as _ from "lodash";

import { Submenu, SubmenuItem, Configuration } from "@/shared-module/models";
import { ConfigurationService, UrlService } from "@/shared-module/services";

@Component({ selector: "app-header", templateUrl: "header.component.html" })
export class HeaderComponent implements OnDestroy {
  @Input() data: Submenu;
  @Input() pageName: string;
  @Input() pageClass: string;
  simulationName : string;
  cssColor: string;
  subs = new SubSink();
  nav: any;

  constructor(
    private router: Router,
    private urlService: UrlService,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => 
        {
          thisObject.cssColor = c.cssColor + "-inv";
          thisObject.simulationName = c.simulation.toLowerCase();
        }
    );
  }

  getTitle(): string {
    this.nav = this.urlService.parseUrl(this.router.url, this.data, true);

    let title = this.pageName;
    if (this.data != null) {
      let nodePath: SubmenuItem;
      if (this.nav.path != null) {
        nodePath = _.find(this.data.items, (el) => el.value === this.nav.path);
        if (nodePath != null) {
          title += ", " + nodePath.caption;
        }
      } else if (this.data.items != null && this.nav.path != "") {
        nodePath = this.data.items[0];
        if (nodePath != null) {
          title += ", " + nodePath.caption;
        }
      }

      if (nodePath != null) {
        let subnodePath: SubmenuItem;
        if (this.nav.subpath != null && this.nav.subpath != "") {
          subnodePath = _.find(
            nodePath.items,
            (el) => el.value === this.nav.subpath,
          );
          if (subnodePath != null) {
            title += ", " + subnodePath.caption;
          }
        } else if (nodePath.items != null) {
          subnodePath = nodePath.items[0];
          if (subnodePath != null) {
            title += ", " + subnodePath.caption;
          }
        }
      }
    }
    return title;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
